import { Navigate, useLocation } from "react-router-dom";
import { setAuthenticated, setToken } from '../../store/slices/loginSlice';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import {
  checkTokenIssuer, getAccessTokenWithAuthCode,
  getIdentityConfiguration, startAuthCodeFlow
} from '../../utils/auth';
import Loader from '../components/Loader';

function Login(props: any) {

  const isAuthenticated = useAppSelector((state) => state.login.authenticated);
  const isLoading = useAppSelector((state) => state.app.loading);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const loginWithAuthCode = () => {
    const identityConfiguration = getIdentityConfiguration();
    const redirectToLogin = async () => {
      const { authorizeUrl, verifier } = await startAuthCodeFlow(identityConfiguration);
      localStorage.setItem("mobilink_verifier", verifier);
      window.location.replace(authorizeUrl);
    }
    redirectToLogin();
  }

  const getTokenWithAuthCode = (authCode: string) => {
    const verifier = localStorage.getItem("mobilink_verifier") as string;
    if (!verifier) {
      return;
    }
    localStorage.removeItem("mobilink_verifier");

    const fetchToken = async () => {
      const identityConfiguration = getIdentityConfiguration();
      const token = await getAccessTokenWithAuthCode(authCode, verifier, identityConfiguration);
      if (token.accessToken && checkTokenIssuer(token.accessToken)) {
        dispatch(setToken(token));
        dispatch(setAuthenticated());
      }
    }

    fetchToken();
  }

  if (isAuthenticated) {
    return (
      <Navigate to="/" replace={true} />
    )
  }
  else if (isLoading) {
    return (
      <Loader />
    )
  } else {
    if (location.hash.includes('error')) {
      return (
        <Navigate to="/?state=loginFailed" replace={true} />
      )
    }

    const params = new URLSearchParams(location.search);

    if (params.has('code')) {
      getTokenWithAuthCode(params.get('code') as string);
    } else {
      loginWithAuthCode();
    }

    return (
      <Loader />
    )
  }
  
}

export default Login;
